import { createReducer } from '@reduxjs/toolkit';

import { clearDeleteOrderedParts } from '../../../actions/coilovers/orderedParts/patchOrderedParts';
import deleteOrderedParts from '../../../thunks/coilovers/orderedParts/deleteOrderedParts';

const initialState = {
  loading: false,
  error: null,
  id: false,
};

const deleteOrderedPartsReducer = createReducer(initialState, {
  [deleteOrderedParts.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [deleteOrderedParts.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    id: payload,
  }),
  [deleteOrderedParts.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [clearDeleteOrderedParts]: () => initialState
});

export default deleteOrderedPartsReducer;
